
import Bookmark from "../../../assets/duotone/Bookmark.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BookmarkIcon({ className, dataTestid = "BookmarkIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Bookmark data-testid={dataTestid} className={classes} {...rest} />
  );
}
